/** H1's route (audit finding 04). */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { H1Verification } from './H1Verification.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (transaction · লেনদেন); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const providerRoutes: RouteObject[] = withSurfaceStates('transaction', [
  { path: '/provider/:id/verification', element: <H1Verification /> },
]);

export { H1Verification, H1VerificationView } from './H1Verification.js';
// `./data.js` is gone. H1 renders `GET /v1/providers/:id/verification`, and the strings
// that used to live there — the shop's name, the badge, both headings, the mediation note
// — are served with the checks (`apps/api/src/provider/screens.ts`).
//
// It is gone for a stronger reason than tidiness. Its `verificationFor(_id)` ignored the
// id it was given and returned one drawn provider's sheet for every provider on the
// platform, so the file was not a cache of the server's answer: it was a different,
// wrong answer that no amount of wiring around it would have corrected.
export * from './api.js';
